import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-calendar/dist/Calendar.css";
import "../src/css/custom.css";
import LoginPage from "./pages/loginPage";
import LanguagePreferencePageHOC from "./pages/langPrefPageHOC";
import IntroPage from "./pages/introPage";
import HomePage from "./pages/homePage";
import HealthInfoWizard from "./pages/healthinfo/healthInfoWizard";
import LandingPage from "./pages/healthinfo/landingPage";
import MyClinicPage from "./pages/myClinicPage";
import MyHealthPage from "./pages/myHealthPage";
import MyAppointmentsPage from "./pages/myAppointmentsPage";
import AppointmentWizard from "./pages/appointment/appointmentWizard";
import OnboardingWizard from "./pages/onboarding/onboardingWizard";
import SetupPasswordPage from "./pages/setupPasswordPage";
import MyHealthInfoPage from "./pages/myHealthInfoPage";
import LibraryPage from "./pages/libraryPage";
import ReferToFriendPage from "./pages/referToFriendPage";
import Mobile from "./components/mobile";
import { useEffect, useState } from "react";
import ProfilePage from "./pages/profilePage";
import SettingPage from "./pages/setting/settingPage";
import UpdatePinNumber from "./pages/setting/updatePinNumber";
import UpdatePassword from "./pages/setting/updatePassword";
import UpdateEmail from "./pages/setting/updateEmail";
import UpdateMobile from "./pages/setting/updateMobile";
import UpdateMobileOtp from "./pages/setting/updateMobileOTP";
import UpdateLanguage1 from "./pages/setting/updateLanguage1";
import ForgotPasswordPage from "./pages/forgetPassword/forgotPasswordPage";
import CheckMailPage from "./pages/forgetPassword/checkMailPage";

import MyChatPage from "./pages/chat/chatPage";
import CreateNewPasswordPage from "./pages/forgetPassword/createNewPasswordPage";
import { useTranslation } from "react-i18next";
import moment from "moment";
import "moment/locale/hi";
import "moment/locale/mr";
import { isUnauthorised, rollbarConfig } from "./utils";
import TermsPage from "./pages/terms";
import PrivacyPage from "./pages/privacy";
import Rollbar from "rollbar";
import TestReportsLanding from "./pages/testReportsLanding";
import MyReports from "./pages/reports/myReports";
import MyPrescriptionsPage from "./pages/prescriptions/myPrescriptionsPage";
import MyTestsPrescriptionsPage from "./pages/reports/myTestsPrescriptionsPage";
import { RollbarContext } from "@rollbar/react";
import SwitchDoctorPage from "./pages/switchDoctor/switchDoctorPage";
import SelectChatPage from "./pages/chat/SelectChatPage";
import DietInfoWizard from "./pages/dietInfo/DietInfoWizard";
import Diet from "./pages/diet/Diet";
import PainScore from "./pages/painScore/painScore";
import PainScoreTracker from "./pages/painScore/painScoreTracker";
import AnkylosingSpondylitisAssessment from "./pages/painScore/ankylosingSpondylitisAssessment";
import AnkylosingSpondylitisScoreTrackerPage from "./pages/painScore/ankylosingSpondylitisScoreTrackerPage";
import RheumatoidArthritisAssessment from "./pages/painScore/rheumatoidArthritisAssessment";
import RheumatoidArthritisScoreTrackerPage from "./pages/painScore/rheumatoidArthritisScoreTrackerPage";
import ScoreCharts from "./pages/scoreCharts/scoreCharts";
import { getToken, onMessage, messaging } from "./firebase";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import createPersistedState from "use-persisted-state";

import FCMProvider from "./components/fcmProvider";
const useProfileState = createPersistedState("profile");
const useAuthTokenState = createPersistedState("token");

function App() {
  const { t, i18n } = useTranslation();
  // Appointment module
  // TODO: This is not a recommended pattern, we shouldn't bring in
  // Appointment specific state in App routes
  const [currentSlot, setCurrentSlot] = useState("");
  const [id, setId] = useState(""); //This is the upcoming doctor App ID if present
  const [isReschedule, setIsReschedule] = useState(false);
  const [attendDetail, setAttendDetail] = useState("");
  const [profile, _] = useProfileState();
  const [authToken, __] = useAuthTokenState();
  // const [isLoggedIn, setIsLoggedIn] = useState(!!authToken);

  const history = useHistory();

  // update mobile otp
  const [newTokenOTP, setNewTokenOTP] = useState({});
  const [toVerifyNumber, setToVerifyNumber] = useState("");

  useEffect(() => {
    console.log(i18n.language);
    moment.locale(i18n.language);
  }, []);

  useEffect(() => {
    let unsubscribe;

    // Service Worker message listener for notification clicks
    const handleSWMessage = (event) => {
      console.log("Received message from SW:", event.data);

      if (event.data && event.data.type === "NOTIFICATION_CLICK_NAVIGATE") {
        const targetUrl = event.data.url;
        const originalUrl = event.data.originalUrl;
        console.log("Navigating to:", targetUrl, "Original:", originalUrl);

        try {
          // Use URL with fallback base (in case targetUrl is relative)
          const url = new URL(targetUrl, window.location.origin);

          if (url.origin === window.location.origin) {
            // Compose path including search/hash
            let path = url.pathname + url.search + url.hash;

            // If your app is served at /patient, ensure we remove that prefix
            const basename = "/patient";
            if (basename && path.startsWith(basename)) {
              path = path.substring(basename.length) || "/";
            }

            console.log("Final navigation path:", path);
            // Use history.replace or push depending on your UX preference
            history.push(path);

            window.focus();
          } else {
            // external link
            window.location.href = targetUrl;
          }
        } catch (error) {
          console.error("Navigation error:", error);
          window.location.href = targetUrl;
        }
      }
    };

    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.addEventListener("message", handleSWMessage);
    }

    unsubscribe = onMessage(messaging, async (payload) => {
      console.log("Foreground payload:", payload);
      const title =
        payload.notification?.title || payload.data?.title || "New message";
      const options = {
        body: payload.notification?.body || payload.data?.body || "",
        icon: "/favicon.ico",
        data: {
          url: payload.data?.url || payload.data?.click_action || "/",
          ...payload.data,
        },
      };

      if (Notification.permission !== "granted") {
        console.warn(
          "Notification permission not granted:",
          Notification.permission
        );
        return;
      }

      try {
        const reg = await navigator.serviceWorker.ready;
        console.log("service worker registration:", reg);

        if (reg && typeof reg.showNotification === "function") {
          await reg.showNotification(title, options);
          return;
        }

        if (reg && reg.active && typeof reg.active.postMessage === "function") {
          reg.active.postMessage({ type: "SHOW_NOTIFICATION", title, options });
          return;
        }

        // final fallback
        const notification = new Notification(title, options);
        notification.onclick = (e) => {
          /* your onclick navigation code */
        };
      } catch (err) {
        console.error("Foreground notification handling error:", err);
      }
    });
    // Cleanup function
    return () => {
      if (typeof unsubscribe === "function") unsubscribe();

      // Remove service worker message listener
      if ("serviceWorker" in navigator) {
        navigator.serviceWorker.removeEventListener("message", handleSWMessage);
      }
    };
  }, [history]);

  return (
    <>
      {profile && authToken && (
        <FCMProvider profile={profile} authToken={authToken} />
      )}

      <Router basename={"/patient"}>
        <Switch>
          <Route exact path="/">
            <RollbarContext context="home">
              <HomePage />
            </RollbarContext>
          </Route>
          <Route exact path="/login">
            <LoginPage />
          </Route>
          <Route exact path="/register">
            <LanguagePreferencePageHOC />
          </Route>
          <Route exact path="/onboarding">
            <OnboardingWizard />
          </Route>
          <Route exact path="/password">
            <SetupPasswordPage />
          </Route>
          <Route exact path="/intro">
            <IntroPage />
          </Route>
          <Route exact path="/home">
            <HomePage />
          </Route>
          <Route exact path="/switch-doctor">
            <SwitchDoctorPage />
          </Route>
          <Route exact path="/health-info">
            <LandingPage />
          </Route>
          <Route exact path="/health-info/start">
            <HealthInfoWizard />
          </Route>
          <Route exact path="/diet-info/start">
            <DietInfoWizard />
          </Route>
          <Route exact path="/diet">
            <Diet />
          </Route>
          <Route exact path="/my-health-info">
            <MyHealthInfoPage />
          </Route>
          <Route exact path="/my-clinic">
            <MyClinicPage />
          </Route>
          <Route exact path="/my-health">
            <MyHealthPage />
          </Route>
          <Route exact path="/my-appointments">
            <MyAppointmentsPage
              setId={setId}
              setIsReschedule={setIsReschedule}
              setAttendDetail={setAttendDetail}
            />
          </Route>
          <Route exact path="/schedule-appointment">
            <AppointmentWizard
              setCurrentSlot={setCurrentSlot}
              currentSlot={currentSlot}
              id={id}
              isReschedule={isReschedule}
              attendDetail={attendDetail}
            />
          </Route>
          <Route exact path="/forgot-password">
            <ForgotPasswordPage />
          </Route>
          <Route exact path="/check-sms">
            <CheckMailPage />
          </Route>
          <Route exact path="/create-new-password">
            <CreateNewPasswordPage />
          </Route>
          <Route exact path="/library">
            <LibraryPage />
          </Route>
          <Route exact path="/refer-friend">
            <ReferToFriendPage />
          </Route>
          <Route exact path="/mobile">
            <Mobile />
          </Route>
          <Route exact path="/my-profile">
            <ProfilePage />
          </Route>
          <Route exact path="/setting">
            <SettingPage />
          </Route>
          <Route exact path="/update-language">
            <UpdateLanguage1 />
          </Route>
          <Route exact path="/update-password">
            <UpdatePassword />
          </Route>
          <Route exact path="/update-mobile">
            <UpdateMobile
              setNewTokenOTP={setNewTokenOTP}
              setToVerifyNumber={setToVerifyNumber}
            />
          </Route>
          <Route exact path="/update-mobile-verify">
            <UpdateMobileOtp
              newTokenOTP={newTokenOTP}
              setNewTokenOTP={setNewTokenOTP}
              toVerifyNumber={toVerifyNumber}
            />
          </Route>
          <Route exact path="/update-email">
            <UpdateEmail />
          </Route>
          <Route exact path="/update-pin">
            <UpdatePinNumber />
          </Route>
          <Route exact path="/terms">
            <TermsPage />
          </Route>
          <Route exact path="/privacy">
            <PrivacyPage />
          </Route>
          <Route exact path="/tests-and-reports">
            <TestReportsLanding />
          </Route>
          <Route exact path="/prescriptions">
            <MyPrescriptionsPage />
          </Route>
          <Route exact path="/my-tests">
            <MyTestsPrescriptionsPage />
          </Route>
          <Route exact path="/select-chat">
            <SelectChatPage />
          </Route>
          <Route exact path="/chat">
            <MyChatPage />
          </Route>
          <Route exact path="/my-reports">
            <MyReports />
          </Route>
          <Route exact path="/pain-score">
            <PainScore />
          </Route>
          <Route exact path="/pain-score/tracker">
            <PainScoreTracker />
          </Route>
          <Route exact path="/pain-score/ankylosing-spondylitis">
            <AnkylosingSpondylitisAssessment />
          </Route>
          <Route exact path="/pain-score/rheumatoid-arthritis">
            <RheumatoidArthritisAssessment />
          </Route>
          <Route exact path="/pain-score/tracker/ankylosing-spondylitis">
            <AnkylosingSpondylitisScoreTrackerPage />
          </Route>
          <Route exact path="/pain-score/tracker/rheumatoid-arthritis">
            <RheumatoidArthritisScoreTrackerPage />
          </Route>
          <Route exact path="/score-chart">
            <ScoreCharts />
          </Route>
          <Route>
            <div>{t("login.404")}</div>
          </Route>
        </Switch>
      </Router>
    </>
  );
}

const rollbar = new Rollbar(rollbarConfig);
// Intercepting Fetch Calls
const { fetch: origFetch } = window;
window.fetch = async (...args) => {
  console.log("fetch called with args:", args);
  const response = await origFetch(...args);

  /* work with the cloned response in a separate promise
     chain -- could use the same chain with `await`. */
  response
    .clone()
    .text()
    .then((response) => {
      try {
        const body = JSON.parse(response);
        if (response.status === 401 || isUnauthorised(body.status)) {
          localStorage.clear();
          window.location.href = "/patient/login";
        }
      } catch (err) {
        rollbar.error(err, { payload: response });
        console.error(err);
      }
    });

  /* the original response can be resolved unmodified: */
  return response;
};

export default App;
